<template>
  <footer class="mt-10 bg-chrome text-onChrome" :class="{ 'scheme-dark': currentThemeAssets?.chrome === 'dark' }">
    <hr class="mx-auto mb-4 max-w-[90rem] border-black" />
    <MContentLayout size="lg" class="inner-footer-container">
      <img
        v-if="currentThemeAssets?.showLogoOnFooter"
        class="h-12 max-w-40 object-contain"
        alt="logo"
        :src="currentThemeAssets?.chrome === 'dark' ? currentThemeAssets?.logoOnDark : currentThemeAssets?.logo" />
      <div class="text-balance" :class="{ 'max-w-[50%]': !currentThemeAssets?.showLogoOnFooter }">
        <div v-for="(cr, cri) in $t('footer_copyright').split('|')" :key="cri" class="inline-block px-1">
          {{ cr }}
        </div>
      </div>

      <MMarkdownRenderer v-if="$te('footer_linksMd')" class="footer-nav-items" :model-value="$t('footer_linksMd')" />
    </MContentLayout>
  </footer>
</template>

<script setup lang="ts">
import { MContentLayout, useTheme, MMarkdownRenderer } from "@moroku/money-webapp-components";
const { currentThemeAssets } = useTheme();
</script>

<style scoped lang="scss">
.inner-footer-container {
  @apply flex flex-col flex-wrap items-start justify-between gap-2 py-4 text-[0.875rem] md:flex-row lg:gap-6;
}

:deep(.footer-nav-items) {
  ul {
    @apply my-0 flex flex-row flex-wrap content-center items-center justify-end gap-8 p-1;
  }

  li {
    @apply list-none;
  }

  a {
    @apply relative text-[#616161];
    transition: all ease 0.3s;

    &:hover {
      text-decoration: none;
      color: #009069;

      &:after {
        transform: scaleX(1);
      }
    }

    &:after {
      @apply absolute bottom-0 left-0 block h-[1px] w-full bg-chromeSecondary;
      content: "";
      transform: scaleX(0);
      transition: transform ease 0.3s;
      transform-origin: 0 0;
    }
  }
}
</style>
